var map = {
	"./Beige.png": "f8ba",
	"./Black Tone.png": "4131",
	"./Black.png": "d876",
	"./Blue.png": "0ed9",
	"./Blue_Mixed.png": "253f",
	"./Brown.png": "02df",
	"./Brown_Mixed.png": "64b1",
	"./Burgundy.png": "3792",
	"./Dark Tone.png": "1b2c",
	"./Gold.png": "8821",
	"./Green.png": "780e",
	"./Green_Mixed.png": "fbad",
	"./Grey.png": "779f",
	"./Grey_Mixed.png": "7d9b",
	"./Ivory.png": "d005",
	"./Khaki.png": "ba24",
	"./Navy.png": "bb73",
	"./Orange.png": "d1b7",
	"./Orange_Mixed.png": "eaf4",
	"./Pink.png": "614a",
	"./Pink_Mixed.png": "644b",
	"./Purple.png": "6db4",
	"./Purple_Mixed.png": "bcbb",
	"./Red.png": "55e8",
	"./Red_Mixed.png": "dc99",
	"./Silver.png": "a58a",
	"./White.png": "bd88",
	"./White_Mixed.png": "a920",
	"./Yellow.png": "2525",
	"./Yellow_Mixed.png": "d3f9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d08";